import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-icon-text-date-cell',
  templateUrl: './icon-text-date-cell.component.html',
  styleUrls: ['./icon-text-date-cell.component.scss'],
})
export class IconTextDateCellComponent {
  @Input() id: string | undefined;
  @Input() title: string | undefined;
  @Input() description: string = '';
  @Input() dateStr: string | undefined | null;
  @Input() dateEnd?: string | undefined | null;
  @Input() hourRangeStr?: string | undefined | null;
  @Input() hourRangeEndStr?: string | undefined | null;
  @Input() scheduled?: boolean = false;
  @Input() type?: string | undefined | null;
  @Input() editRoute: string | any[] | null | undefined;
  @Input() detailsRoute: string | any[] | null | undefined;

  @Output() clickToExpand = new EventEmitter<boolean>();
  @Output() clickToEdit = new EventEmitter<string>();
  @Output() action = new EventEmitter<string>();

  openUserViewed: boolean = true;

  constructor() {}

  showUsersViewed() {
    this.openUserViewed = !this.openUserViewed;
    this.clickToExpand.emit(!this.openUserViewed);
  }

  actionEdit() {
    this.clickToEdit.emit('actionEdit');
  }

  handleSelectedOption(evt: any) {
    if (evt === 'actionEdit') {
      this.action.emit('actionEdit');
    }
    if (evt === 'actionDetails') {
      this.action.emit('actionDetails');
    }
    if (evt === 'actionDuplicate') {
      this.action.emit('actionDuplicate');
    }
    if (evt === 'actionDelete') {
      this.action.emit('actionDelete');
    }
  }
}
